import {Pipe, PipeTransform} from '@angular/core';

export const DEFAULT_MAX_LENGTH = 64;

@Pipe({
  name: 'middleEllipsis'
})
export class MiddleEllipsisPipe implements PipeTransform {

  transform(value: string | null | undefined, maxLength: number = DEFAULT_MAX_LENGTH): string {
    if (!value) {
      return '';
    }
    if (value.length <= maxLength || maxLength <= 3) {
      return value;
    }
    const visibleCharacters = maxLength - 3;
    const prefixLength = Math.ceil(visibleCharacters / 2);
    const suffixLength = Math.floor(visibleCharacters / 2);
    return value.substring(0, prefixLength) + '...' + value.substring(value.length - suffixLength);
  }
}
